import { render, staticRenderFns } from "./-Sidebar.vue?vue&type=template&id=2e0d47f9&scoped=true&"
import script from "./-Sidebar.vue?vue&type=script&lang=js&"
export * from "./-Sidebar.vue?vue&type=script&lang=js&"
import style0 from "./-Sidebar.vue?vue&type=style&index=0&id=2e0d47f9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0d47f9",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LinkTo: require('/app/workspace/DEPLOY/ibu-owt-core/ibu-owt-core-owt-ssr-nuxt/components/LinkTo.vue').default})
